import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import Flex from "../../../../../../../../components/Flex";
import PatientSendAssessments from "../PatientAssementForms/SchedulePatientAssementForms";
import PatientSubmittedAssessmentNewTable from "../PatientSubmittedAssessmentNewTable";
import AssessmentSummaryGraph from "./AssessmentSummaryGraph";
import CardView from "./components/CardView";

const AssessmentSummaryLayout = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  return (
    <Flex flexDirection={"column"} gap={2} p={1}>
      <CardView
        title="Summary Trend"
        titleIcon={<BarChartOutlinedIcon color="primary" fontSize="small" />}
      >
        {/* <OutlineCard> */}
        <AssessmentSummaryGraph />
        {/* </OutlineCard> */}
      </CardView>

      {/* <Flex gap={1} height={"100%"} width={"100%"}>
        <CardView
          title="Clinical Details"
          titleIcon={<PersonOutlinedIcon color="primary" fontSize="small" />}
        >
          <Flex maxHeight={"340px"} width={"100%"} height={"100%"} gap={1.5}>
            <Box width="33.33%" height="100%">
              <CardView
                withExpand={false}
                title="Upcoming Appointments"
                titleIcon={
                  <DateRangeOutlinedIcon color="primary" fontSize="small" />
                }
              >
                <UpcomingAppointments />
              </CardView>
            </Box>

            <Box width="33.33%" height="100%">
              <CardView
                withExpand={false}
                title="Medications"
                titleIcon={
                  <MedicationOutlinedIcon color="primary" fontSize="small" />
                }
              >
                <AssessmentMedications />
              </CardView>
            </Box>

            <Box width="33.33%" height="100%">
              <CardView
                withExpand={false}
                title="Diagnosis"
                titleIcon={<FeedIcon color="primary" fontSize="small" />}
              >
                <AssessmentDiagnosis />
              </CardView>
            </Box> */}

      {/* other fields */}
      {/* </Flex>
        </CardView>
      </Flex> */}
      <CardView
        endAction={
          <FormControlLabel
            control={
              <Checkbox
                checked={isSubmitted}
                onChange={(e) => {
                  setIsSubmitted(e.target.checked);
                }}
              />
            }
            label="Show Submitted Assessments"
            sx={{ whiteSpace: "nowrap" }}
          />
        }
        title="Sent & Submitted Assessments"
        titleIcon={<SummarizeOutlinedIcon color="primary" fontSize="small" />}
      >
        {isSubmitted ? (
          <PatientSubmittedAssessmentNewTable />
        ) : (
          <PatientSendAssessments />
        )}
      </CardView>
      {/* <CardView
        title="Screening Assessments"
        titleIcon={<SummarizeOutlinedIcon color="primary" fontSize="small" />}
      >
        <ScreeningTable />
      </CardView> */}
    </Flex>
  );
};

export default AssessmentSummaryLayout;
